import { callApi } from "./index"

type Extra = {
  id: number;
  description: string;
  rrpPrice: number;
};

type PackageItem = {
  id: number;
  supplierName: string;
  name: string;
  rrpPrice: number;
  supplierListingImage: string;
  extras: Extra[];
};

type CategoryExtra = {
  extraId: number;
  quantity: number;
};

type Category = {
  categoryId: number;
  categoryName: string;
  packageItem: PackageItem;
  extras: CategoryExtra[];
};

export type VwpCart = {
  uuid: string;
  weddingDate: string;
  categories: Category[];
  redeemPoints: boolean;
  wedPointsSpent: number;
  wedPointsRedeemRate: number;
  wedPointsEarnRate: number;
  subTotal: number;
  wedPointsTotalRedeemValue: number;
  totalAfterWedPoints: number;
  userWedPoints?: number;
};

export const getVwpCart = (): Promise<VwpCart> => {
  return callApi(`/packages/cart/items/`)
}
